<template>
    <div class="step bugget-btn">
        <AdvTitle>{{ $t("common:signLog.adv.budgetTitle") }}</AdvTitle>
        <div class="adv-btn-group">
            <AdvBtn
                v-for="item in list"
                :key="item"
                type="reverse"
                @click="handleNext(item)"
            >{{ item }}</AdvBtn
            >
        </div>
        <div class="adv-progress-wrap">
            <AdvProgress :value="progress()"></AdvProgress>
        </div>
    </div>
</template>
<script>
import AdvBtn from './components/btn.vue';
import AdvProgress from './components/progress.vue';
import AdvTitle from './components/title.vue';
export default {
    inject: ['progress', 'next'],
    data: function() {
        return {
            list: ['1', '2', '3', '4+']
        };
    },
    methods: {
        handleNext(item) {
            this.next({ budget: item });
        }
    },
    components: {
        AdvBtn,
        AdvProgress,
        AdvTitle
    }
};
</script>
<style lang="scss">
.adv-progress-wrap {
    padding-top: 30px;
}
</style>
